<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições com as seguintes áreas embargadas - GO:

        .list-group
            a.list-group-item.list-group-item-action
                .row
                    label.col-3 Número do processo
                    label.col-3 CPF/CNPJ
                    label.col-5 Nome

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in areaEmbargada.restricoes'
            )
                .row
                    .col-3
                        span {{ restricao.properties.numero_processo_sga }}

                    .col-3
                        span {{ restricao.properties.cpf_cnpj }}

                    .col-5
                        span {{ restricao.properties.nome_embargado }}

    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoAreaEmbargadaGO"'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';

import LayerStyle from '@/utils/layerStyles';

export default {
    name: 'AreaEmbargadaGO',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        areaEmbargada: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            required: true
        }
    },
    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.areaEmbargada.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'Áreas embargadas - GO',
                    tooltip: `Nome: ${feature.properties.nome} - ${feature.properties.cpf_cnpj}`
                };

                this.layersMaps.push(layerRestricao);
            });
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
